(function () {
    'use strict';

    angular.module('app').controller('CrateConfigModalController', CrateConfigModalController);
    CrateConfigModalController.$inject = [
        '$uibModalInstance',
        'Units',
        'Carrier',
        'toastr',
        'Currency',
        '$q'
    ];

    function CrateConfigModalController(
        $uibModalInstance,
        Units,
        Carrier,
        toastr,
        Currency,
        $q
    ) {
        const vm = this;

        vm.measureUnits = Units.measureUnit;
        vm.currencies = [];
        vm.crateData = {};
        vm.isLoading = false;
        vm.closeModal = closeModal;
        vm.save = save;

        init();

        function init() {
            getCurrency().then(() => {
                getCrateDetails();
            });
        }

        function getCrateDetails() {
            Carrier.getCrateConfig(data => {
                setCrateDetails(data);
            }, error => { });
        }

        function setCrateDetails(data) {
            vm.crateData = angular.copy(data);
            vm.crateData.currency = vm.currencies.find(currency => currency.currencyCode == data.currency);
            vm.crateData.measureUnit = vm.measureUnits.find(unit => unit.short == data.measureUnit);
        }

        function getCurrency() {
            const defer = $q.defer();

            Currency.getList((data) => {
                vm.currencies = data;
                defer.resolve(data);
            });

            return defer.promise;
        }

        function closeModal() {
            $uibModalInstance.close();
        }

        function save(crateForm) {
            if (crateForm.$invalid) { return; }
            if (vm.crateData.id) {
                updateConfig();
                return;
            }

            createConfig();
        }

        function updateConfig() {
            vm.isLoading = true;
            Carrier.updateCrateConfig(generatePayload(), (data) => {
                vm.crateData = data;
                setCrateDetails(data);
                toastr.success('Successfully Update!');
                vm.isLoading = false;
                toastr.success('Successfully Update!');
            }, error => {
                vm.isLoading = false;
                toastr.error(error, "Error");
            });
        }

        function createConfig() {
            vm.isLoading = true;
            Carrier.createCrateArtworkConfig(generatePayload(), (data) => {
                vm.crateData = data;
                setCrateDetails(data);
                toastr.success('Successfully save!');
                vm.isLoading = false;
                toastr.success('Successfully save!');
            }, error => {
                vm.isLoading = false;
                toastr.error(error, "Error");
            });
        }
 
        function generatePayload() {
            return {
                currency: vm.crateData.currency.currencyCode,
                enabled: vm.crateData.enabled,
                heightIncrement: vm.crateData.heightIncrement,
                heightIncrementRate: vm.crateData.heightIncrementRate,
                lengthAndWidthDivisor: vm.crateData.lengthAndWidthDivisor,
                lengthAndWidthRate: vm.crateData.lengthAndWidthRate,
                measureUnit: vm.crateData.measureUnit.short,
                minimumRate: vm.crateData.minimumRate,
                cubicConversionFactor: vm.crateData.cubicConversionFactor
            };
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/carriers/CrateConfigModalController.js